import { useState } from "react";
import {
  PopoverContent,
  PopoverPortal,
  Root as PopoverRoot,
  PopoverTrigger,
} from "@radix-ui/react-popover";
import clsx from "clsx";
import { useLocation, useNavigate } from "react-router-dom";
import { useNetworksStore } from "store/networksStore";
import { usePoolsStore } from "store/poolsStore";
import { defaultNetworkIconUrl } from "../../../../constants";

export const NetworkSwitcher = () => {
  const { networks, currentNetwork, setCurrentNetwork } = useNetworksStore();
  const [isOpen, setOpen] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { resetStore } = usePoolsStore();

  const isPoolPage = pathname.includes("/pool/pools");

  const handleOpenChange = (val: boolean) => {
    setOpen(val);
  };

  return (
    <PopoverRoot open={isOpen} onOpenChange={handleOpenChange}>
      <PopoverTrigger disabled={!networks?.length}>
        {!networks?.length || !currentNetwork ? (
          <div className="flex h-[45px] w-[45px] items-center justify-center overflow-hidden rounded-8 bg-white dark:bg-blue-darkMode-10">
            <img
              className="h-[36px] w-[36px] rounded-8"
              src={defaultNetworkIconUrl}
              alt="chain"
            />
          </div>
        ) : (
          <button className="flex h-[45px] w-[45px] items-center justify-center overflow-hidden rounded-8 bg-white dark:bg-blue-darkMode-10">
            <img
              className="h-[36px] w-[36px] rounded-8 object-cover"
              src={currentNetwork?.iconUrl}
              alt="chain"
            />
          </button>
        )}
      </PopoverTrigger>

      {isOpen && (
        <PopoverPortal forceMount>
          <PopoverContent
            asChild
            avoidCollisions={false}
            sideOffset={8}
            align="end"
          >
            <div
              className={clsx(
                "relative z-[500] flex h-auto max-h-[200px] min-w-[141px] flex-col rounded-8 bg-white p-1 shadow-sm dark:bg-blue-darkMode-30 dark:text-white"
              )}
            >
              <div className="flex w-full flex-col gap-3 overflow-auto">
                {networks &&
                  networks.map((el) => (
                    <button
                      key={el.chainId || el.id}
                      onClick={() => {
                        if (currentNetwork?.id === el.id) return;
                        if (isPoolPage) navigate("/pool");

                        resetStore();

                        setCurrentNetwork(el);

                        handleOpenChange(false);
                      }}
                      className={clsx(
                        "flex w-full items-center gap-2 rounded-8 p-1 hover:bg-blue-light dark:hover:bg-blue-darkMode-10",
                        el.id === currentNetwork?.id &&
                          "bg-blue-light-10 dark:bg-blue-darkMode-20"
                      )}
                    >
                      <img
                        className="h-[28px] w-[28px] rounded-full object-cover"
                        src={el?.iconUrl}
                        alt="chain"
                      />
                      {el.name}
                    </button>
                  ))}
              </div>
            </div>
          </PopoverContent>
        </PopoverPortal>
      )}
    </PopoverRoot>
  );
};
